import { Link } from "react-router-dom";
import { PublicLayout } from "../../components/public-layout.js";
import { HeroSection } from "../../components/marketing-components.js";

export function SupportPage() {
  return (
    <PublicLayout>
      <HeroSection
        title="Support"
        subtitle="Answers to common questions and how to get help"
      />

      <section className="marketing-section">
        <div className="section-content">
          <h2>Frequently asked questions</h2>

          <div className="faq-list">
            <div className="faq-item">
              <h3>How long does a scan take?</h3>
              <p>
                Depends on site size. A typical scan of 100-200 pages takes
                10-30 minutes. Large sites (1000+ pages) may take several hours.
                We'll show you progress in real-time.
              </p>
            </div>

            <div className="faq-item">
              <h3>Why is my scan partial or incomplete?</h3>
              <p>
                Common reasons: JavaScript errors preventing page load, login
                required, robots.txt blocking, or network timeouts. We'll flag
                these in your report with next steps.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can you scan single-page applications (SPAs)?</h3>
              <p>
                Yes, we use a real browser. We can test SPAs, but be aware: if
                pages are heavily dynamic and load on user interaction, we may
                miss some content.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you scan protected content (paywalls, login)?</h3>
              <p>
                By default, no. We scan publicly available pages. For protected
                content, contact us about custom scanning or manual review.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can I pick which pages to scan?</h3>
              <p>
                You define templates (homepage, product page, etc.) and we scan
                those intelligently. For more granular control, contact us.
              </p>
            </div>

            <div className="faq-item">
              <h3>What WCAG standards do you support?</h3>
              <p>
                We test against WCAG 2.1 Level A and AA. Level AAA is available
                but much stricter and rarely required by law. Pick your baseline
                in scan settings.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can I export my findings?</h3>
              <p>
                Yes. Download detailed PDF reports, CSV findings lists, or
                integrate via API. Contact us for specific export needs.
              </p>
            </div>

            <div className="faq-item">
              <h3>How often should I scan?</h3>
              <p>
                We recommend monthly to catch issues early. Minimum is
                quarterly. More frequently if you deploy often.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you provide remediation guidance?</h3>
              <p>
                Yes. Each finding includes context, what failed, and general
                fixes. For deep expertise, pair with manual review.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is my data private and secure?</h3>
              <p>
                Your scans are private to your organization. We use encryption
                in transit and at rest. We don't sell or share your data.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="marketing-section marketing-section--alt">
        <div className="section-content">
          <h2>Common issues and solutions</h2>

          <div className="troubleshooting">
            <div className="trouble-item">
              <h4>🚫 404 errors during scan</h4>
              <p>
                We found broken links or pages that changed. Most common during
                site migrations. Check your sitemap.
              </p>
            </div>

            <div className="trouble-item">
              <h4>⏱️ Scan timeout</h4>
              <p>
                Page took too long to load. Usually due to slow CDN, external
                services, or computationally expensive JavaScript. Optimize and
                retry.
              </p>
            </div>

            <div className="trouble-item">
              <h4>🔒 SSL/certificate warning</h4>
              <p>
                We couldn't verify your site's SSL. Check certificate expiry and
                renewal. We need HTTPS.
              </p>
            </div>

            <div className="trouble-item">
              <h4>📦 WAF or bot blocking</h4>
              <p>
                Your Web Application Firewall (WAF) is blocking our scanner.
                Whitelist our IP or user agent. Contact us for details.
              </p>
            </div>

            <div className="trouble-item">
              <h4>❓ Unexpected findings</h4>
              <p>
                False positive? Let us know. We can tune rules or exclude
                certain patterns. Reply to your scan notification.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="marketing-section">
        <div className="section-content">
          <h2>Contact support</h2>

          <p>For issues not covered above, reach out to our support team:</p>

          <div className="contact-methods">
            <div className="contact-method">
              <h4>📧 Email</h4>
              <p>
                <a href="mailto:support@accessimonitor.app">
                  support@accessimonitor.app
                </a>
              </p>
              <p style={{ fontSize: "0.9em", color: "#666" }}>
                Response time: 24 hours on business days
              </p>
            </div>

            <div className="contact-method">
              <h4>💬 Email support</h4>
              <p>Email support available during business hours (9am–5pm UTC)</p>
            </div>

            <div className="contact-method">
              <h4>📞 Demo / Sales</h4>
              <p>
                <Link to="/contact">Request a demo or talk to sales</Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
